const all = ['files']
const detail = (fileId?: number) => [...all, fileId]

export const fileKeys = { all, detail }
